import React from "react";
import "./Bootcamp.css";

const Bootcamp = () => {
  const checkoutUrl = "https://learn.forgeyourpeak.in/web/checkout/698a8ef1831f481067f8b8f1";

  return (
    <main className="fyp-bootcamp">
      {/* HERO */}
      <section className="v2-section bc-hero">
        <div className="v2-container bc-hero-inner">
          <div className="bc-hero-copy">
            <h1 className="bc-title">Reset Your Eyes.<br/>React Faster.<br/>Perform Sharper.</h1>
            <p className="bc-sub">3-Day neuroscience based performance reset for competitive athletes.</p>
            <div className="bc-ctaRow">
              <a className="bc-ctaPrimary" href={checkoutUrl} target="_blank" rel="noopener noreferrer">Join Bootcamp for ₹499</a>
            </div>
          </div>
          <div className="bc-hero-media">
            <img src="/FYP-Bootcamp/HeroSection.jpg" alt="Bootcamp"/>
          </div>
        </div>
      </section>

      {/* PROBLEM STATEMENT */}
      <section className="v2-section bc-problem">
        <div className="v2-container bc-problem-inner">
          <div className="bc-problem-media">
            <img src="/FYP-Bootcamp/Problem.jpg" alt="Problem"/>
          </div>
          <div className="bc-problem-copy">
            <h3 className="bc-problem-title">Most Athletes Train Their Body.<br/><span className="bc-accent">Few Train Their Visual System.</span></h3>
            <div className="bc-chips">
              <span>Late Ball Pickup</span>
              <span>Slow First Step</span>
              <span>Inconsistent Timing</span>
              <span>Eye Fatigue</span>
              <span>Poor Decision Clarity</span>
            </div>
          </div>
        </div>
      </section>

      {/* CURRICULUM 3 DAYS */}
      <section className="v2-section bc-days">
        <div className="v2-container">
          <h2 className="bc-h2">What Happens in 3 Days</h2>

          <div className="bc-dayRow">
            <div className="bc-dayCopy">
              <h4>Day 1 – Test</h4>
              <ul>
                <li>Measure visual Clarity</li>
                <li>Measure neural-processing speed</li>
                <li>Benchmark your baseline</li>
              </ul>
            </div>
            <div className="bc-dayMedia"><img src="/FYP-Bootcamp/Measure.png" alt="Day 1 - Test"/></div>
          </div>

          <div className="bc-dayRow">
            <div className="bc-dayCopy">
              <h4>Day 2 – Train</h4>
              <ul>
                <li>Learn to rest your visual system</li>
                <li>Improve hand-eye Coordination</li>
                <li>Train your brain for faster reactions</li>
              </ul>
            </div>
            <div className="bc-dayMedia"><img src="/FYP-Bootcamp/Train.png" alt="Day 2 - Train"/></div>
          </div>

          <div className="bc-dayRow">
            <div className="bc-dayCopy">
              <h4>Day 3 – Transform</h4>
              <ul>
                <li>Match‑day carryover plan</li>
                <li>Basic visual reset protocol</li>
              </ul>
            </div>
            <div className="bc-dayMedia"><img src="/FYP-Bootcamp/Transform.png" alt="Day 3 - Transform"/></div>
          </div>
        </div>
      </section>

      {/* WHAT YOU GET */}
      <section className="v2-section bc-get">
        <div className="v2-container">
          <h2 className="bc-h2">What You Get</h2>
          <div className="bc-get-grid">
            <div className="bc-pill">✓ 3-Day Guided Visual Reset System</div>
            <div className="bc-pill">✓ Visual Fatigue Recovery Protocol</div>
            <div className="bc-pill">✓ Reaction Trigger Activation Drills</div>
            <div className="bc-pill">✓ Self-Check Progress Framework</div>
            <div className="bc-pill">✓ Access to Private Athlete Community</div>
            <div className="bc-pill">✓ Pathway to Unlock FYP – Ignite </div>
          </div>
        </div>
      </section>

      {/* CTA FOOTER */}
      <section className="v2-section bc-ctaFooter">
        <div className="v2-container bc-ctaFooter-inner">
          <img src="/FYP-Bootcamp/Footer.png" alt="Bootcamp CTA" className="bc-ctaBannerImg" />
          <div className="bc-ctaCenter">
            <h3>Your Body Is Ready.<br/>Is Your Visual System?</h3>
            <a className="bc-ctaPrimary" href={checkoutUrl} target="_blank" rel="noopener noreferrer">Start Now – ₹499</a>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Bootcamp;
